import { render } from "./WCAccountSidebar.vue?vue&type=template&id=1276a2f2&scoped=true"
import script from "./WCAccountSidebar.vue?vue&type=script&lang=js"
export * from "./WCAccountSidebar.vue?vue&type=script&lang=js"

import "./WCAccountSidebar.vue?vue&type=style&index=0&id=1276a2f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1276a2f2"]])

export default __exports__